import { Component, ElementRef, OnInit, Renderer2, ViewChild, AfterContentInit, Output, EventEmitter } from '@angular/core';

declare let Checkout: any;
@Component({
  selector: 'app-payment-banamex',
  templateUrl: './payment-banamex.component.html',
  styleUrls: ['./payment-banamex.component.scss']
})
export class PaymentBanamexComponent {

  @Output() paymentProcess: EventEmitter<{
    status: number,
    message: string
  }> = new EventEmitter<{
    status: number,
    message: string
  }>();

  @ViewChild('embedTarget') embedTarget!: ElementRef;

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
  }
  ngAfterContentInit(): void {
    // setTimeout(() => {
    this.loadScript('https://evopaymentsmexico.gateway.mastercard.com/static/checkout/checkout.min.js').then(() => { 
      Checkout.configure({
        session: {
          id: 'SESSION0002660512594K5663002I40'
        }
      });
      Checkout.showEmbeddedPage('#embed-target');
    });
    // }, 1000)
  }

  loadScript(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = resolve;
      script.onerror = reject;
      script.setAttribute('data-complete', 'completeCallback');
      script.setAttribute('data-error', 'errorCallback');
      script.setAttribute('data-cancel', 'cancelCallback');
      script.setAttribute('data-timeout', 'timeOutCallback');
      (window as any)['completeCallback'] = this.completeCallback.bind(this);
      (window as any)['errorCallback'] = this.errorCallback.bind(this);
      (window as any)['cancelCallback'] = this.cancelCallback.bind(this);
      (window as any)['timeOutCallback'] = this.timeOutCallback.bind(this);
      document.body.appendChild(script);
    });
  }

  completeCallback(result: any) {
    this.paymentProcess.emit({
      status: 1,
      message: result
    });

  }

  errorCallback(error: any) {
    this.paymentProcess.emit({
      status: 0,
      message: error
    });
  }

  timeOutCallback(data:any) {
    this.paymentProcess.emit({
      status: 2,
      message: data
    });
  }

  cancelCallback() {
    console.log('Payment cancelled');
  }

  payWithEmbeddedPage() {
    Checkout.showEmbeddedPage('#embed-target');

  }

  payWithPaymentPage() {
    Checkout.showPaymentPage();
  }

}
